import { render, staticRenderFns } from "./PrizeCreditsHistory.vue?vue&type=template&id=b7f8e95e&"
import script from "./PrizeCreditsHistory.vue?vue&type=script&lang=js&"
export * from "./PrizeCreditsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports